<template>
  <p class="total-text">{{formatValue(netLoan)}} €</p>
  <p class="total-sub-text">{{$store.getters.translations.net_loan}}</p>
</template>

<script>
export default {
  name: "NetLoan",
  props:['netLoan'],
  methods:{
    formatValue(value){
      return value.toLocaleString('de-DE')
    }
  }
}
</script>

<style scoped>

</style>
